import moment from 'moment';

const useDocumentUrl = () => {
  //const roleList = useAppSelector((state) => state.appConfig.roleList);

  const getDocumentUrl = (role,documentList) => {
    const docs = documentList?.filter(
      (doc) => doc.documentName == role?.Title
    );

    if(docs?.length > 1 ){
      const recentItems = docs.sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate))).slice(0, 1);
      return recentItems[0].documentURL;
    }
    else if(docs.length > 0){
      return docs[0].documentURL;
    }
  };

  const getDocumentName = (role,documentList) => {
    const docs = documentList?.filter(
      (doc) => doc.documentName == role?.Title
    );

    if(docs?.length > 1 ){
      const recentItems = docs.sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate))).slice(0, 1);
      return recentItems[0].documentName;
    }
    else if(docs.length > 0){
      return docs[0].documentName;
    }
  };

  return { getDocumentUrl, getDocumentName };
};

export default useDocumentUrl;
